import { useState } from "react";

const KINDS = [["done", "rewritten", "bg-emerald-50 text-emerald-800 border-emerald-200"], ["kept", "kept as it was", "bg-amber-50 text-amber-800 border-amber-200"],
  ["failed", "failed", "bg-red-50 text-red-700 border-red-200"]];
const NOTE = { done: "", kept: "The AI's reply was shorter than the page, so the original text stays.", failed: "Something went wrong — try this page again." };

export const RewriteSummary = ({ st }) => {
  const [open, setOpen] = useState(null);
  const items = open ? st[open] || [] : [];
  return (
    <div data-testid="rewrite-summary" className="mt-2">
      <div className="flex flex-wrap gap-2">
        {KINDS.map(([k, label, cls]) => {
          const n = (st[k] || []).length;
          return (
            <button key={k} data-testid={`rewrite-summary-${k}`} disabled={!n} onClick={() => setOpen(open === k ? null : k)}
              className={`rounded-full border px-3 py-1 text-xs font-semibold transition-opacity disabled:opacity-50 ${cls} ${open === k ? "ring-1 ring-current" : ""}`}>
              {n} {label}
            </button>
          );
        })}
      </div>
      {open && (
        <div data-testid={`rewrite-summary-list-${open}`} className="mt-2">
          {NOTE[open] && <p className="text-xs text-stone-500">{NOTE[open]}</p>}
          <ul className="mt-1 list-disc pl-5 text-xs text-stone-600">
            {items.map((p) => <li key={p.block}>p.{p.n} · {p.label}{open === "failed" && p.error ? ` — ${p.error}` : ""}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
};
